import React from 'react'
import { CameraProps, StyledCameraIcon } from './IconCamera.styled'

export interface IconCameraProps {
    title?: string
    fill?: string
}

export const IconCamera: React.FC<IconCameraProps & CameraProps> = ({
    className,
    title,
    width,
    height,
    horizontalSpacing,
    fill,
}) => (
    <StyledCameraIcon
        width={width}
        height={height}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        fill="none"
        horizontalSpacing={horizontalSpacing}
    >
        <title>{title || 'Camera Icon'}</title>
        <path
            d="M11.666 5.25C11.666 4.92783 11.4048 4.66667 11.0827 4.66667H10.5404C9.95526 4.66666 9.40887 4.37421 9.08431 3.88737L8.61035 3.17643C8.50217 3.01416 8.32003 2.91668 8.125 2.91667H5.8737C5.67867 2.91668 5.49653 3.01416 5.38835 3.17643L4.91439 3.88737C4.58983 4.37421 4.04344 4.66666 3.45833 4.66667H2.91602C2.59385 4.66667 2.33268 4.92783 2.33268 5.25V10.5C2.33268 10.8222 2.59385 11.0833 2.91602 11.0833H11.0827C11.4048 11.0833 11.666 10.8222 11.666 10.5V5.25ZM8.16602 7.58333C8.16602 6.939 7.64368 6.41667 6.99935 6.41667C6.35502 6.41667 5.83268 6.939 5.83268 7.58333C5.83268 8.22767 6.35502 8.75 6.99935 8.75C7.64368 8.75 8.16602 8.22767 8.16602 7.58333ZM9.33268 7.58333C9.33268 8.872 8.28801 9.91667 6.99935 9.91667C5.71068 9.91667 4.66602 8.872 4.66602 7.58333C4.66602 6.29467 5.71068 5.25 6.99935 5.25C8.28801 5.25 9.33268 6.29467 9.33268 7.58333ZM12.8327 10.5C12.8327 11.4665 12.0492 12.25 11.0827 12.25H2.91602C1.94952 12.25 1.16602 11.4665 1.16602 10.5V5.25C1.16602 4.2835 1.94952 3.5 2.91602 3.5H3.45833C3.65336 3.49999 3.8355 3.40251 3.94369 3.24023L4.41764 2.5293C4.7422 2.04246 5.28859 1.75001 5.8737 1.75H8.125C8.71011 1.75001 9.2565 2.04246 9.58106 2.5293L10.055 3.24023C10.1632 3.40251 10.3453 3.49999 10.5404 3.5H11.0827C12.0492 3.5 12.8327 4.2835 12.8327 5.25V10.5Z"
            fill={fill ?? '#535556'}
        />
    </StyledCameraIcon>
)
IconCamera.displayName = 'IconCamera'
